import { pxToRem } from '@theme/utils/sizing';

export const drop = {
  background: 'gray-50',
  border: {
    width: '0px',
    radius: pxToRem(12),
  },
  intelligentMargin: true,
  margin: '0px',
  elevation: 'medium',
  zIndex: 20,
};
